enum VendorNumberOrigin {
  Autogenerated, // eslint-disable-line no-unused-vars
  ERPIntegration, // eslint-disable-line no-unused-vars
  ManualAssignment, // eslint-disable-line no-unused-vars
}

export default VendorNumberOrigin;
